export class ReProcessingDtoReq{
    product: number;
    brand: number;
    minGrade: number;
    maxGrade: number;
    finalPercentage?:number;
    requiredRmQty?:number;
    variantId?:number[];
}